import React, { useState, useRef, useEffect } from "react";
import Up from "../images/move_up.svg";
import rectagnle from "../images/rectagnle.svg";

const OutlineElement = ({ top, height, resizingSet, isResizing, isErrored }) => {
  const outlineRef = useRef(null);

  // Function to handle resizing of the outline
  //   const handleResize = (e) => {
  //     const isMovingUp = e.movementY<0;
  //
  //     e.preventDefault();
  //     const newHeight = outlineRef.current.clientHeight + e.movementY;
  //     outlineRef.current.style.height = `${newHeight}px`;
  //   };

  //   // Attach event listener for resizing when the component mounts
  //   useEffect(() => {
  //     const handleMouseUp = () => {
  //       document.removeEventListener('mousemove', handleResize);
  //       document.removeEventListener('mouseup', handleMouseUp);
  //     };

  //     outlineRef.current.addEventListener('mousedown', (e) => {
  //       document.addEventListener('mousemove', handleResize);
  //       document.addEventListener('mouseup', handleMouseUp);
  //     });
  //   }, []);

  return (
    <div
      ref={outlineRef}
      id="outline_component"
      className={`outline ${isErrored?"red":""}`}
      style={{ top, height: height, textAlign: "center", ...((!isResizing||1)&&{zIndex:2}) }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onDrop={(e) => {
        e.stopPropagation();
      }}
      onDag={(e) => {
        e.stopPropagation();
      }}>
      {/* Resizing handle */}
      <div
        className="dragger_top"
        onDragStart={(e) => {
          e.preventDefault();
        }}
        onMouseDown={(e) => {
          resizingSet(true, true, e);
        }}
        onMouseUp={(e) => {
          resizingSet(false, false, e);
        }}>
        <img
          src={Up}
          alt=""
          style={{
            position: "absolute",
            top: "-5px",
            zIndex: 9,
            left: "50%",
            transform: "translate(-50%, 0)",
            cursor: "ns-resize"
          }}
        />
        <img
          src={rectagnle}
          alt=""
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translate(-50%, 0)",
            cursor: "ns-resize"
          }}
        />
      </div>
      <div
        className="dragger_bottom"
        onDragStart={(e) => {
          e.preventDefault();
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          resizingSet(true, false, e);
        }}
        onMouseUp={(e) => {
          resizingSet(false, false, e);
        }}>
        <img
          src={rectagnle}
          alt=""
          style={{
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, 0)",
            bottom: "-2px",
            cursor: "ns-resize"
          }}
        />
        <img
          src={Up}
          alt=""
          style={{
            position: "absolute",
            bottom: "-6px",
            left: "50%",
            zIndex: 9,
            transform: "rotate(180deg) translate(50%, 0)",
            cursor: "ns-resize"
          }}
        />
      </div>
      <div className="resize-handle" />
    </div>
  );
};

export default OutlineElement;
